export const permissionOnboard = /**@type {const} */ ([
  {
    method: 'GET',
    route: 'staff-request/get-staff-requests',
    name: 'View',
    mapKey: 'GET_ONBOARD',
  },
]);
